import Breadcrumbs from '@package/components/Breadcrumbs';

export default Breadcrumbs;
